{{#if config.label}}
  {{> elements/_page_builder_label label=config.label description=config.description}}
{{/if}}
<div class="icon-editor">
  <div class="tool-field">
    <sp-button class="preview" size="large" variant="outlined">
      <sp-icon name={{context}} size="large"></sp-icon>
    </sp-button>
  </div>
</div>
<div class="customized shared-component-options">
  <a href="" class="reset">{{{ icon "close-alt-color" }}} Remove Override</a>
</div>
